;(function($, undefined){
    'use strict';

    var rnn = window.rnn;

    function initArticle() {
        $('.relatedContentTrigger').click(function() {
            var $theTrigger = $(this);

            $theTrigger.toggleClass('hideItems');

            if($theTrigger.hasClass('hideItems')){
                $theTrigger.html('Show Less <i class="icon9x9-collapseup-icon"></i>');
                $('.newsEntry ul li.hiddenItem').slideDown('slow', function() {
                    // animation finished
                });
            }else{
                $theTrigger.html('Show More <i class="icon9x9-dropdown-icon"></i>');
                $('.newsEntry ul li.hiddenItem').slideUp('slow', function() {
                    // animation finished
                });
            }
        });

        var $articleParas = $('.newsEntry article .story-body > p');

        if ($articleParas.length > 3) {
            var $related = $('.newsEntry .relatedcontent'),
                $space = $articleParas.eq(2),
                $adFragment = $('.mobileAd1Fragment');

            if ($related.length > 0) {
                $related.insertAfter($space);
                $space = $related;
            }

            if ($adFragment.length > 0) {
                $adFragment.detach().removeClass('hidden').insertAfter($space);
            }
        }
    }

    rnn.modules.register('article', {
        init: initArticle
    });

})(jQuery);
